import React, { useState, useEffect } from 'react';
import { 
  Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Paper 
} from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DeleteIcon from '@mui/icons-material/Delete';
import LabelIcon from '@mui/icons-material/Label';

import { handleExpedicaoAction, getExpedicoes } from '../services/api';
import ConfirmModalMUI from '../warehouse/modals/ConfirmModalMUI';
import FeedbackModalMUI from '../warehouse/modals/FeedbackModalMUI';
import OrderDetails from './OrderDetails';  // Certifique-se de ajustar o caminho conforme necessário

const ExpedicoesCriadas = ({ apiBaseURL, reload, onVerPaletesReload }) => {
  const [expedicoes, setExpedicoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Estados para confirmação/feedback
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderDetailsModalOpen, setOrderDetailsModalOpen] = useState(false);

  const handleRowClick = (order) => {
    setSelectedOrder(order);
    setOrderDetailsModalOpen(true);
  };

  const fetchExpedicoes = () => {
    setLoading(true);   // <<< aqui
    getExpedicoes()
      .then(response => {
        setExpedicoes(response.data);
        setError(null);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchExpedicoes();
  }, [apiBaseURL, reload]);

  // Ao clicar em um botão de ação (etiquetas, enviar ou eliminar),
  // armazena a ação e o order_id e abre o modal de confirmação
  const handleActionClick = (order_id, action) => {
    setSelectedOrderId(order_id);
    setSelectedAction(action);
    setConfirmModalOpen(true);
  };

  // Quando o usuário confirma a ação:
  const handleConfirmAction = async () => {
  setConfirmModalOpen(false);
  setFeedbackModalOpen(true);
  setIsSubmitting(true);
  try {
    const response = await handleExpedicaoAction(selectedOrderId, selectedAction);
    const message = response.data.message || response.data.url || "Ação concluída";
    setFeedbackMessage(message);
    fetchExpedicoes();

    if (selectedAction === 'enviar' && onVerPaletesReload) {
      onVerPaletesReload();
    }
  } catch (err) {
    console.error(err);
    setFeedbackMessage("Erro ao executar ação");
  } finally {
    setIsSubmitting(false);
  }
};

  const handleConfirmCancel = () => {
    setConfirmModalOpen(false);
  };

  const handleFeedbackClose = () => {
    setFeedbackModalOpen(false);
    setFeedbackMessage("");
    setSelectedAction(null);
    setSelectedOrderId(null);
  };

  if (loading) return <Typography>Carregando expedições...</Typography>;
  if (error) return <Typography color="error">Erro: {error}</Typography>;

  return (
    <>
      <Box mt={2}>
        <Typography variant="h6" gutterBottom>Expedições Criadas</Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Order ID</strong></TableCell>
                <TableCell><strong>Nome do pedido</strong></TableCell>
                <TableCell><strong>Data de Criação</strong></TableCell>
                <TableCell><strong>Status</strong></TableCell>
                <TableCell align="center"><strong>Ações</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {expedicoes.map((expedicao) => (
                <TableRow 
                  key={expedicao.order_id}
                  hover
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleRowClick(expedicao)}
                >
                  <TableCell>{expedicao.order_id}</TableCell>
                  <TableCell>{expedicao.invoice_number}</TableCell>
                  <TableCell>{new Date(expedicao.created_at).toLocaleString()}</TableCell>
                  <TableCell>{expedicao.status_info.status}</TableCell>
                  <TableCell align="center">
                    <IconButton 
                      onClick={(e) => { 
                        e.stopPropagation();
                        handleActionClick(expedicao.order_id, 'etiquetas');
                      }}
                    >
                      <LabelIcon />
                    </IconButton>
                    <IconButton 
                      onClick={(e) => { 
                        e.stopPropagation();
                        handleActionClick(expedicao.order_id, 'enviar');
                      }}
                    >
                      <LocalShippingIcon />
                    </IconButton>
                    <IconButton 
                      onClick={(e) => { 
                        e.stopPropagation();
                        handleActionClick(expedicao.order_id, 'eliminar');
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      
      {/* Modal de Confirmação */}
      <ConfirmModalMUI 
        open={confirmModalOpen} 
        message={`Tem certeza que deseja ${selectedAction} esta expedição?`}
        onConfirm={handleConfirmAction}
        onCancel={handleConfirmCancel}
      />
      
      {/* Modal de Feedback */}
      <FeedbackModalMUI 
        open={feedbackModalOpen} 
        isSubmitting={isSubmitting}
        submissionComplete={!isSubmitting && feedbackMessage !== ""}
        error={feedbackMessage && feedbackMessage !== "Ação concluída" ? feedbackMessage : null}
        onClose={handleFeedbackClose}
      />
      
      {/* Modal de Detalhes da Ordem */}
      {orderDetailsModalOpen && selectedOrder && (
        <OrderDetails
          open={orderDetailsModalOpen}
          order={selectedOrder}
          onClose={() => setOrderDetailsModalOpen(false)}
          refreshExpedicoes={fetchExpedicoes}
        />
      )}
    </>
  );
};

export default ExpedicoesCriadas;
